import YoutubeShort from './youtube-short';

export default (di) => {
	di
		.setType({type: YoutubeShort, name: 'YoutubeShort', parent: 'PageComponent'})
	;
};
